import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Web3Provider } from './providers/Web3Provider'
import 'react-toastify/dist/ReactToastify.css';
import { store } from './Redux/store';
import { Provider } from 'react-redux';
import { ThemeProvider } from './hooks/ThemeProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
    <Web3Provider>
      <ThemeProvider>
      <App/>
      </ThemeProvider>
    </Web3Provider>
    </Provider>
  </React.StrictMode>
);
